import ITexts from "./ITexts";

const de: ITexts = {
  project_updates_not_found: "Es liegen keine Updates vor."
};

export default de;
